import MUIButton from "@mui/material/Button";

const Button = MUIButton;

export default Button;
